import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=b83fde3a&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b83fde3a')) {
      api.createRecord('b83fde3a', component.options)
    } else {
      api.reload('b83fde3a', component.options)
    }
    module.hot.accept("./ClientList.vue?vue&type=template&id=b83fde3a&", function () {
      api.rerender('b83fde3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/ClientList.vue"
export default component.exports